import { Component } from '@angular/core';
import {IonicPage, NavController, NavOptions, Platform} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Photo} from "../../models/data.model";
import {PhotosViewerPage} from "../photos-viewer/photos-viewer";

@IonicPage()
@Component({
  selector: 'page-book',
  templateUrl: 'book.html',
})
export class BookPage {

  constructor(public data: DataProvider, public navCtrl: NavController) {
  }

  protected getBookContent(): string {
    return (this.data.getBookContent() !== null) ? this.data.getBookContent().text : "";
  }

  protected clickText(event: Event) {
    const element: HTMLElement = <HTMLElement>event.target;
    if (element.nodeName != "IMG") return;
    const photo: Photo = {
      name: "photo",
      url: (<HTMLImageElement>element).src
    };
    this.navCtrl.push(PhotosViewerPage, {
      photos: [photo]
    }).catch();
  }

}



// WEBPACK FOOTER //
// ./src/pages/book/book.ts